import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExcel,
  faPalette,
  faTruck,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import "./dashboard.scss";
import Header from "../../compnents/Header";
import Footer from "../../compnents/Footer";
import { useSelector } from "react-redux";

function Motherboard() {
  const [userName, setUserName] = useState("");
  const [permission, setPermission] = useState(false); // ✅ default false
  const [checktrue, setCheckTrue] = useState(false);
  const navigate = useNavigate();

  const AuthReducer = useSelector((state) => state?.AuthReducer?.loginResponse);
  const access = AuthReducer?.data?.access_details || [];
  const isAdmin = AuthReducer?.data?.is_admin;
  // const isAdmin = true;

  useEffect(() => {
    setCheckTrue(AuthReducer?.data?.is_active === 1);
  }, [AuthReducer]);

  useEffect(() => {
    try {
      const stored = localStorage.getItem("user");
      const parsedUser = stored ? JSON.parse(stored) : null;
      const nameToUse = AuthReducer?.data?.name || parsedUser?.email || "";
      setUserName(nameToUse);
    } catch (error) {
      console.error("Failed to parse user from localStorage:", error);
      setUserName("");
    }
  }, [AuthReducer]);

  // ✅ check dashboard access for non-admins
  useEffect(() => {
    if (!isAdmin && access?.length > 0) {
      const dashboardPerm =
        access.find((item) => item.menu_code === "dashboard")?.is_enabled ??
        false;
      setPermission(dashboardPerm);
    } else if (isAdmin) {
      setPermission(true); // admin always true
    }
  }, [access, isAdmin]);

  const filteredAccess = access?.filter(
    (item) => item.menu_code !== "dashboard"
  );

  const iconMap = {
    "art-work": faPalette,
    "bulk-order": faTruck,
    "modern-trade": faFileExcel,
    "meeting-room": faUsers,
  };

  return (
    <>
      <Header />
      <Container>
        {checktrue ? (
          isAdmin || permission ? (
            <div className="main-board text-center">
              {userName && !userName.includes("@") ? (
                <h1>
                  Hi, {userName} <br />
                  Welcome to <span>Dot Connect</span>
                </h1>
              ) : (
                <h1>
                  Hi, User
                  <br />
                  Welcome to <span>Dot Connect.</span>
                </h1>
              )}

              <p className="mb-5">Please select your option</p>

              <Row className="justify-content-center">
                {(isAdmin
                  ? filteredAccess
                  : filteredAccess?.filter((list) => list.is_enabled)
                )?.map((list) => (
                  <Col key={list.menu_code} md={3} sm={6} xs={6}>
                    <div
                      className="each-opt"
                      onClick={() =>
                        navigate(
                          list.menu_code === "bulk-order"
                            ? `/${list.menu_code}`
                            : `/dashboard/${list.menu_code}`,
                          isAdmin
                            ? {
                                state: {
                                  access: {
                                    r: true,
                                    w: true,
                                    u: true,
                                    full: true,
                                  }, // full access for admin
                                  service: list.menu_name,
                                },
                              }
                            : {
                                state: {
                                  access:
                                    list.access_type === "full"
                                      ? "full"
                                      : {
                                          r: list.access?.read,
                                          w: list.access?.write,
                                          u: list.access?.update,
                                        },
                                  service: list.menu_name,
                                },
                              }
                        )
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <div className="icon">
                        <FontAwesomeIcon
                          icon={iconMap[list.menu_code] || null}
                        />
                      </div>
                      <div className="card-dtls">
                        <h4>{list?.menu_name}</h4>
                        <p>Manage your {list?.menu_name}</p>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          ) : (
            <div className="permission-wrapper">
              <div className="permission">
                <h1>Oops!</h1>
                <p>Please contact the Admin for the access</p>
              </div>
            </div>
          )
        ) : (
          <div className="permission-wrapper">
            <div className="permission">
              <h1>Oops!</h1>
              <p>You do not have access of this portal, please contact Admin</p>
            </div>
          </div>
        )}
      </Container>
      <Footer />
    </>
  );
}

export default Motherboard;
